import type { SVGProps } from 'react';

export type OnboardingIconProps = SVGProps<SVGSVGElement> & {
  className?: string;
};

export const iconStroke = {
  strokeWidth: 1.35,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};
